import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Box,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverCloseButton,
  PopoverContent,
  PopoverContentProps,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";
import { ReactNode } from "react";

interface InfoPopoverProps extends PopoverContentProps {
  children: ReactNode;
  ariaLabel?: string;
}

/**
 * Renders a help/info icon that shows a markdown explanation in a popover.
 */
export const InfoPopover: React.FC<InfoPopoverProps> = ({ children, ariaLabel, ...props }) => (
  <Popover placement="right" isLazy>
    <PopoverTrigger>
      <IconButton
        aria-label={ariaLabel || "Toelichting"}
        icon={<InfoOutlineIcon />}
        variant="accent"
        tabIndex={0}
      />
    </PopoverTrigger>
    <Portal>
      <PopoverContent {...props}>
        <PopoverArrow />
        <PopoverCloseButton />
        <Box p={4} fontSize="sm">
          {children}
        </Box>
      </PopoverContent>
    </Portal>
  </Popover>
);
